/* REDUX */
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { fetchSftpAuthenticationTypesDictionary } from 'app/actions/dictionaries/sftp-authentication-types.actions';
import * as api from 'report-subscriptions/resources/sftp.api';
import sftpCreateTemplate from './sftp-create.html';

const DIRTY_FORM = 'sftpCreate';

const mapStateToThis = ({ dictionary }) => {
  const { sftpAuthenticationTypes } = dictionary;
  return {
    authenticationTypes: sftpAuthenticationTypes,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchSftpAuthenticationTypesDictionary,
};

@Inject('$ngRedux', 'gettextCatalog', '$state', 'Responsive', 'Notifications')
class SftpCreateController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.fileErrors = {};
    this.savingInProgress = false;
    this.DIRTY_FORM = DIRTY_FORM;
    this.enabledSelectOptions = [
      {
        label: this.gettextCatalog.getString('No'),
        value: false,
      },
      {
        label: this.gettextCatalog.getString('Yes'),
        value: true,
      },
    ];
    this.sftp = {
      configuration: {
        authenticationType: 'PASSWORD',
      },
    };
    await this.fetchSftpAuthenticationTypesDictionary();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  submitForm(form) {
    form.$setSubmitted();

    if (form.$invalid) {
      return;
    }

    this.submitConfirm();
  }

  async submitConfirm() {
    try {
      this.savingInProgress = true;
      await api.createSftp(this.sftp);
      this.Notifications.alertSuccess(this.gettextCatalog.getString('Configuration has been created'));
      this.setDirtyForm(DIRTY_FORM, false);
      this.$state.go('sftp-view', { skipDirtyForms: true });
    } catch (error) {
      console.error('CREATE_SFTP', error);
    } finally {
      this.savingInProgress = false;
    }
  }
}

export default class SftpCreateComponent {
  constructor() {
    this.template = sftpCreateTemplate;
    this.controller = SftpCreateController;
    this.bindings = {
      model: '<',
      api: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/management/sftp/sftp-create/sftp-create-component.js